// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const UserModelRecord = require('client-v2/common/models/user/record')

const bem = BemEntity('ShareModalUserContent')

function ShareModalUserContent(props) {
  const { user } = props
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.element('details')
      )
    },
      tag('div', {
        className: bem.element('short-name')
      },
        '@' + user.username
      ),
      tag('div', {
        className: bem.element('full-name')
      },
        user['display_name']
      )
    )
  )
}

ShareModalUserContent.propTypes = {
  className: PropTypes.string,
  user: PropTypes.shape(UserModelRecord.propTypes)
}

module.exports = ShareModalUserContent
